/**
 * =========================================================================================
 *     Copyright © 2026 Dobler Data Solutions, LLC. ALL RIGHTS RESERVED.
 * =========================================================================================
 *     File            :   GrowthFreezeBanner.tsx
 *     Feature         :   286 - FCM licence enforcement and estate limits (US4, FR-006)
 *     Description     :   The growth-freeze banner (contracts/portal-gating.md): when the session's
 *                         license.withheld is non-empty — the backend sends it to Admin and SuperAdmin
 *                         only — say, per kind, that the estate is over its tier's limit and new
 *                         entities of that kind are not being added since the freeze date. A
 *                         persistent system-status banner (the kit Alert); renders nothing otherwise.
 *     Author          :   Peter Dobler
 * =========================================================================================
 */
import React from 'react';
import { Alert } from '@/components/ui';
import { useAuthStore } from '../../stores/authStore';
import { formatEasternDate } from '@/utils/dateFormatter';

export const GrowthFreezeBanner: React.FC = () => {
  const withheld = useAuthStore((s) => s.license?.withheld);
  if (!withheld || withheld.length === 0) return null;
  return (
    <Alert variant="warning" title="Growth limit reached" className="mb-6">
      {withheld.map((k) => (
        <p key={k.kind}>
          Your estate is over the {k.kind} limit of your tier ({k.count} of {k.limit}). New {k.kind} are not
          being added since {formatEasternDate(k.growthFrozenFrom)}.
        </p>
      ))}
      <p className="mt-1">Nothing already collected is affected.</p>
    </Alert>
  );
};

export default GrowthFreezeBanner;
